/** Recovered receipts invalidate current owned reads; they never replay an old row. */
const listeners = new Set<(userId: string) => void>();
export function subscribeHabitChanges(listener: (userId: string) => void) {
  listeners.add(listener); return () => { listeners.delete(listener); };
}
export function publishHabitRefresh(userId: string) { listeners.forEach(listener => listener(userId)); }
